import type { StatusDimension } from '@rallyshift/design-system'

/**
 * Dutch labels for every status the portal shows. The colour, glyph and shape come
 * from StatusBadge; this only supplies the words, so the six status dimensions stay
 * consistent no matter which screen renders them.
 */
const LABELS: Record<StatusDimension, Record<string, string>> = {
  volunteer: {
    invited: 'Uitgenodigd',
    applied: 'Aangemeld',
    pending: 'In behandeling',
    approved: 'Goedgekeurd',
    active: 'Actief',
    rejected: 'Afgewezen',
    suspended: 'Geblokkeerd',
    inactive: 'Inactief',
  },
  shift: {
    draft: 'Concept',
    published: 'Gepubliceerd',
    active: 'Actief',
    completed: 'Afgerond',
    cancelled: 'Geannuleerd',
  },
  event: {
    upcoming: 'Aankomend',
    ongoing: 'Bezig',
    completed: 'Afgelopen',
  },
  assignment: {
    assigned: 'Toegewezen',
    confirmed: 'Bevestigd',
    completed: 'Voltooid',
    cancelled: 'Geannuleerd',
  },
  attendance: {
    expected: 'Verwacht',
    'checked-in': 'Ingecheckt',
    late: 'Te laat',
    'no-show': 'Niet gekomen',
    'checked-out': 'Uitgecheckt',
  },
  visibility: {
    public: 'Openbaar',
    private: 'Besloten',
  },
}

export function statusLabel(dimension: StatusDimension, status: string): string {
  return LABELS[dimension]?.[status] ?? status
}

const ROLE_LABELS: Record<string, string> = {
  owner: 'Eigenaar',
  admin: 'Beheerder',
  coordinator: 'Coördinator',
  volunteer: 'Vrijwilliger',
  user: 'Gebruiker',
}

export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role
}

/** Organiser roles get the emphasised tag, so a beheerder stands out in a roster. */
export function isOrganiserRole(role: string): boolean {
  return role === 'owner' || role === 'admin' || role === 'coordinator'
}

/** Dutch words for the capacity states, passed straight to the Capacity primitive. */
export const CAPACITY_LABELS = {
  open: 'open',
  filling: 'vult',
  full: 'vol',
  over: 'overboekt',
}
